import React from "react";
import App from "./App";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ForgotPassword from "./Components/ForgotPassword.js";
import { createRoot } from "react-dom/client";
import AboutUs from "./Components/AboutUs.js";
import PrivacyPolicy from "./Components/PrivacyPolicy.js";
import TermsOfService from "./Components/TermsOfService.js";
import Footer from "./Components/Footer.js";
import Navbar from "./Components/Navbar.js";

const routes = [
  { path: "/", element: <App /> },
  { path: "/login", element: <App /> },
  { path: "/signup", element: <App /> },
  { path: "/resetpassword", element: <ForgotPassword /> },
];

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
  <BrowserRouter>
    <Routes>
        {routes.map((entry, index) => (
          <Route key={index} path={entry.path} element={entry.element} />
        ))}
        <Route
          path="/about"
          element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <AboutUs />
              <Footer />
            </div>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <PrivacyPolicy />
              <Footer />
            </div>
          }
        />
        <Route
          path="/terms-of-service"
          element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <TermsOfService />
              <Footer />
            </div>
          }
        />
    </Routes>
  </BrowserRouter>
  </React.StrictMode>
);

